import { getConfig } from '../config';

import base64Decode from './base64/decode';

const config = getConfig();

export function isProduction() {
  if (typeof window === 'undefined') {
    return false;
  }

  const { host } = window.location;

  return host === config.domain || host === `www.${config.domain}`;
}

export function getDecodedConfigStrFunction(prodStrKey, stagingStrKey) {
  return () => {
    const str64 = isProduction() ? config[prodStrKey] : config[stagingStrKey];
    return base64Decode(str64);
  };
}

export const getDiscoveryUrl = getDecodedConfigStrFunction('discoveryUrlEncodedProd', 'discoveryUrlEncodedStaging');
export const getInviterUrl = getDecodedConfigStrFunction('inviterUrlEncodedProd', 'inviterUrlEncodedStaging');
export const getInviterPjUrl = getDecodedConfigStrFunction('inviterPjUrlEncodedProd', 'inviterPjUrlEncodedStaging');
export const getBackendURL = getDecodedConfigStrFunction('backendUrlEncodedProd', 'backendUrlEncodedStaging');
export const getSentryDnsUrl = getDecodedConfigStrFunction('sentryDnsEncodedProd', 'sentryDnsEncodedStaging');
